let defaultSiteLog = {
    _id: null,
    correlation_id: null,
    title: '',
    tenant_id: null,
    action: '',
    tags: '',
    user_id: null,
    user_name: '',
    ip: '',
    type: '',
    log: '',
    date: '',
};

export default defaultSiteLog;

